import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ISeries } from 'app/data-studio-redesign/interfaces/data-studio.interface';
import { chartTypesOptions } from 'app/data-studio-redesign/services/data-analysis-helper';
import { MatSort } from '@angular/material/sort';

@Component({
    selector: 'app-signals-list',
    templateUrl: './signals-list.component.html',
    styleUrls: ['./signals-list.component.scss'],
    standalone: false
})

export class SignalsListComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() series: ISeries[];
  @Input() loadingSerie: boolean;
  @Input() disabled: boolean;
  @Input() theme: string;
  @Input() granOptions: { names: string[], values: string[] };
  @Output() changeVisibility = new EventEmitter();
  @Output() updateSerie = new EventEmitter();
  @Output() deleteSeries = new EventEmitter();

  @ViewChild(MatSort) sort: MatSort;

  public displayedColumns = ['parkName', 'turbine', 'deviceType', 'signal', 'granularity', 'color', 'style'];
  public chartTypes = {
    names: [ 'DATA_STUDIO.DATA_ANALYSIS.CHART_TYPE.AREA', 'DATA_STUDIO.DATA_ANALYSIS.CHART_TYPE.AREA_SPLINE', 'DATA_STUDIO.DATA_ANALYSIS.CHART_TYPE.CIRCLE', 'DATA_STUDIO.DATA_ANALYSIS.CHART_TYPE.COLUMN', 'DATA_STUDIO.DATA_ANALYSIS.CHART_TYPE.DASHED_LINE', 'DATA_STUDIO.DATA_ANALYSIS.CHART_TYPE.DIAMOND', 'DATA_STUDIO.DATA_ANALYSIS.CHART_TYPE.DOTTED_LINE', 'DATA_STUDIO.DATA_ANALYSIS.CHART_TYPE.LINE', 'DATA_STUDIO.DATA_ANALYSIS.CHART_TYPE.STEPPED_LINE', 'DATA_STUDIO.DATA_ANALYSIS.CHART_TYPE.TRIANGLE' ],
    values: { ...chartTypesOptions }
  };

  public defaultColorList: string[] = ['#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#911eb4', '#46f0f0', '#f032e6', '#bcf60c', '#fabebe', '#008080', '#e6beff', '#9a6324', '#ffffff', '#000000'];

  public dataSource: MatTableDataSource<ISeries>;
  public selection = new SelectionModel(true, []);

  public ngOnInit(): void {
    this.displayedColumns.push('edit');
    this.displayedColumns.unshift('checkbox')
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.series) {
      this.selection.clear();
      this.dataSource = new MatTableDataSource<ISeries>(this.series);
    }

    if(changes.granOptions) {
      setTimeout(() => {
      const options = changes.granOptions.currentValue.values;
      this.dataSource.filteredData.forEach(item => {
        if (!options.includes(item.granularity)) {
          this.selectchartGranularity({option: options[0], index: 0}, item);
        }
      })
      })
    }
  }

  public ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  public masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.series.forEach(row => this.selection.select(row));
    this.deleteSeries.emit({series: [...this.selection?.selected], confirm: true});
  }

  public isAllSelected() {
    return this.selection?.selected?.length === this.series?.length;
  }

  public selectionChanged(event, row) {
    if (event) {
      this.selection.toggle(row);
      this.deleteSeries.emit({series: [...this.selection?.selected], confirm: true});
    }
  }

  public toggleVisibility(row) {
    if (this.disabled) return;
    row.visible = !row.visible;
    this.changeVisibility.emit(row);
  }

  public selectchartType({option, index}, data) {
    data.chartTypeName = option;
    this.updateSerie.emit({type: 'seriesType', serie: {...data, ...this.chartTypes.values[index]}});
    const elemIndex = this.series.findIndex(item => item.id === data.id);
    this.series[elemIndex] = {...data, ...this.chartTypes.values[index]};
    this.dataSource = new MatTableDataSource<ISeries>(this.series);
  }

  public selectchartGranularity({option, index}, data) {
    data.granularity = option;
    this.updateSerie.emit({type: 'granularity', serie: {...data, granularity: option}, dataUpdate: true});
  }

  public changeColor(serie) {
    this.updateSerie.emit({type: 'color', serie});
  }

  public selectOption(element) {
    this.deleteSeries.emit({type: 'delete', series: [element], confirm: false});
  }

}
